import React from "react"
import { ThemeProvider } from "styled-components"
import { theme } from "../config"
import ResetStyles from "../styles/reset"
import GlobalStyles from "../styles/global"
import Sprite from "./primitives/sprite"
import MenuController from "./constructs/menu-controller"


const Layout = ({ location, title, children, pagePath, t, languages, i18n, originalPath, footer }) => {

  const { socials, support, about } = footer
  const processedServices = []
  const processedPages = null
  
  return (
    <ThemeProvider theme={theme}>      
      <MenuController
        title={title}
        services={processedServices}
        pages={processedPages}
        // use about or combinedAbout
        about={about}
        socials={socials}
        // use support or combinedSupport
        support={support}
        footerContent={footer}
        t={t}
        languages={languages}
        i18n={i18n}
        originalPath={originalPath}
      >
        <main>{children}</main>
      </MenuController>
      <ResetStyles />
      <GlobalStyles />
      <Sprite />
    </ThemeProvider>
  )
}

export default Layout
